/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

/**
 * replaces the empty spaces with an underscore so origin can be used as id for elements
 *
 * @param {string} origin -
 * @returns {string} -
 */
export const getIdFromOrigin = (origin = '') => {
  return String(origin).replace(/\s/g, '_')
}
